module.exports = __webpack_public_path__ + "img/icon-user2.b1a3cc1e.svg";